import { fileChecksum } from "bundles/common/utils/fileChecksum";
import { directUpload } from "bundles/common/utils/uploadDocument";
import sh from "bundles/common/utils/sh";

export const uploadCvToVault = async (file) => {
  const checksum = await fileChecksum(file);

  const { data } = await sh.get("/internal/cv_vault_items/check", { params: { checksum } });
  if (data?.duplicate) return { duplicate: data };

  const presigned = await directUpload(file, "cv_vault", "application/pdf");

  const created = await sh.post("/internal/cv_vault_items", {
    blob_signed_id: presigned.blob_signed_id,
    filename: file.name,
  });

  return { item: created.data };
};
